import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import type { AppState } from '../setup'

const selectCustomer = (state: AppState) => state.customer

// TODO: move to ../hooks
export const useCustomer = () => {
  const customer = useSelector(selectCustomer)

  return useMemo(
    () => ({
      customer,
    }),
    [customer]
  )
}
